import Table from 'components/Table';
import { useState } from 'react';
import FarmerDrawer from '../farmer-drawer';
import renderFarmerTableHeader from './FarmersTableHeader';

const FarmersTable = ({ data, isLoading, pagination }) => {
  const {
    total,
    currentPage: current,
    pageSize,
    handlePageChange: onChange,
  } = pagination;

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(false);
  const [showFGLData, setShowFGLData] = useState(false);

  const handleClick = (rowData) => {
    setSelectedRowData(rowData);
    setIsDrawerOpen(true);
  };

  const handleDrawerClose = (event) => {
    const clickedOnMask = event?.target?.classList?.[0] === 'ant-drawer-mask';

    if (showFGLData) {
      if (clickedOnMask) {
        setSelectedRowData(null);
        setIsDrawerOpen(false);
      }
      setShowFGLData(false);
      return;
    }

    setSelectedRowData(null);
    setIsDrawerOpen(false);
  };

  return (
    <>
      <Table
        tableColumns={data}
        tableHeader={renderFarmerTableHeader(handleClick)}
        loading={isLoading}
        highlightColor="gray"
        highlighted={selectedRowData?.id}
        pagination={{
          total,
          current,
          pageSize,
          onChange,
          onShowSizeChange: onChange,
        }}
      />
      <FarmerDrawer
        data={{
          ...selectedRowData,
          role: selectedRowData?.isGroupLeader ? 'Group Leader' : 'Farmer',
        }}
        isOpen={isDrawerOpen}
        onClose={handleDrawerClose}
        showFGLData={showFGLData}
        setShowFGLData={setShowFGLData}
      />
    </>
  );
};

export default FarmersTable;
